import { createSlice } from "@reduxjs/toolkit";

const initialPostsState = {
  postsList: [],
  listLoading: false,
  error: null,
  hideLoading: false,
  postHided: null,
  categoriesList: [],
  newPost: null,
  poll: null,
  pollLoading: false,
  fetchPost: null,
  fetchPostLoading: false,
  postDraftEdited: null,
  postDeleted: null,
  drafPost:  []
};

export const callTypes = {
  list: "list",
  hide: "hide",
};

export const postsSlice = createSlice({
  name: "Posts",
  initialState: initialPostsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.payload.error}`;
      switch (action.payload.callType) {
        case callTypes.list:
          state.listLoading = false;
          break;
        case callTypes.hide:
          state.hideLoading = false;
          break;
        default:
          break;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      switch (action.payload.callType) {
        case callTypes.list:
          state.listLoading = true;
          break;
        case callTypes.hide:
          state.hideLoading = true;
          break;
        default:
          break;
      }
    },
    postsFetched: (state, action) => {
      state.postsList = action.payload.postsList;
      state.listLoading = false;
      state.error = null;
    },
    postHided: (state, action) => {
      state.postHided = action.payload.postHided;
      state.hideLoading = false;
      state.error = null;
    },
    categoriesFetched: (state, action) => {
      state.categoriesList = action.payload.categoriesList;
      state.listLoading = false;
      state.error = null;
    },
    postCreated: (state, action) => {
      state.newPost = action.payload.newPost;
      state.listLoading = false;
      state.hideLoading = false;
      state.error = null;
    },
    postDraftEdited: (state, action) => {
      state.postDraftEdited = action.payload.postDraftEdited;
      state.listLoading = false;
      state.hideLoading = false;
      state.error = null;
    },
    deletePost: (state, action) => {
      state.postDeleted = action.payload.postDeleted;
      state.listLoading = false;
      state.hideLoading = false;
      state.error = null;
    },
    drafPost: (state, action) => {
      state.drafPost = action.payload.drafPost;
      state.listLoading = false;
      state.hideLoading = false;
      state.error = null;
    },
    postPollCreated: (state, action) => {
      state.poll = action.payload.poll;
      state.pollLoading = false;
      state.error = null;
    },
    getPost: (state, action) => {
      state.fetchPost = action.payload.fetchPost;
      state.fetchPostLoading = false;
      state.error = null;
    },
  },
});
